app.controller('ContactCtrl', ['$scope', 'ContactService', 'Contacts', function($scope, ContactService, Contacts) {
  $scope.contacts = Contacts;
  $scope.mainContact = {};
  $scope.sectors = ["Expérience crèche", "Expérience entreprise", "Comptabilité et facturation"];
}]);
